import _isArray from 'lodash/isArray'

const hydrateWatchlist = (items: any, watchlistIds: number[]) => {
  if (!_isArray(items))
    return [{ ...items, addedToWatchlist: watchlistIds.includes(items.id) }]

  return items.map((item) => ({
    ...item,
    addedToWatchlist: watchlistIds.includes(item.id),
  }))
}

export default hydrateWatchlist
